import { render, staticRenderFns } from "./BatchTab.vue?vue&type=template&id=1813ee16&scoped=true&"
import script from "./BatchTab.vue?vue&type=script&lang=js&"
export * from "./BatchTab.vue?vue&type=script&lang=js&"
import style0 from "./BatchTab.vue?vue&type=style&index=0&id=1813ee16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813ee16",
  null
  
)

export default component.exports